import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

var MenuHeading = function MenuHeading(_ref) {
  var menuLinks = _ref.menuLinks,
      activeIndex = _ref.activeIndex,
      LinkTemplate = _ref.LinkTemplate;
  return /*#__PURE__*/React.createElement("ul", {
    className: "menu__top--heading"
  }, menuLinks.map(function (menuLink, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: menuLink.heading && menuLink.heading.text
    }, /*#__PURE__*/React.createElement(LinkTemplate, {
      url: menuLink.heading.url,
      className: classnames('menu__top--heading-item link', {
        'menu__top--heading-item--active': activeIndex === index
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "link__content"
    }, menuLink.heading.text)));
  }));
};

var MenuTop = function MenuTop(_ref2) {
  var LinkTemplate = _ref2.LinkTemplate,
      activeIndex = _ref2.activeIndex,
      menuLinks = _ref2.menuLinks;
  return /*#__PURE__*/React.createElement("div", {
    className: "menu__top"
  }, /*#__PURE__*/React.createElement(MenuHeading, {
    LinkTemplate: LinkTemplate,
    activeIndex: activeIndex,
    menuLinks: menuLinks
  }));
};

MenuTop.propTypes = {
  menuLinks: PropTypes.array,
  activeIndex: PropTypes.number,
  LinkTemplate: PropTypes.func
};
MenuTop.defaultProps = {
  menuLinks: [],
  activeIndex: 0
};
export default MenuTop;